import Vue from 'vue';
import Router from 'vue-router';

import home from '@/page/home.vue';
import Contact from '@/page/Contact.vue';
import AboutUs from '@/page/AboutUs.vue';
 
 
Vue.use(Router);
 
const router = new Router({
  mode: 'hash',
  routes: [
	{
	  path: '/',
	  name: 'home',
	  component: home
	},
	{
	  path: '/Contact',
	  name: 'Contact',
	  component: Contact
	},
	{
	  path: '/AboutUs',
	  name: 'AboutUs',
	  component: AboutUs
	},
	
    // 其他路由配置...
  ]
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;